__turbopack_context__.v({
  "layout": "NextLayout-module__eUgjca__layout",
  "main": "NextLayout-module__eUgjca__main",
});
